import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import Meta from './Meta';
import AppRouter from './Router';
import GlobalStyle from './styles/GlobalStyle';
import theme from '../theme';
import { store } from '../db';

const App = () => {
  console.log('Form - Speech Polling ver.0.1.1');
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Meta />
        <GlobalStyle />
        <AppRouter />
      </ThemeProvider>
    </Provider>
  );
};

export default App;
